import React from "react";

export default function FileSave({ fill = "#FAFAFA", width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.5869 5.22563L12.7744 2.41313C12.7218 2.361 12.6595 2.31976 12.5909 2.29176C12.5224 2.26377 12.449 2.24958 12.375 2.25001H3.375C3.07663 2.25001 2.79048 2.36854 2.5795 2.57951C2.36853 2.79049 2.25 3.07664 2.25 3.37501V14.625C2.25 14.9234 2.36853 15.2095 2.5795 15.4205C2.79048 15.6315 3.07663 15.75 3.375 15.75H14.625C14.9234 15.75 15.2095 15.6315 15.4205 15.4205C15.6315 15.2095 15.75 14.9234 15.75 14.625V5.62501C15.7504 5.55098 15.7362 5.4776 15.7082 5.40906C15.6803 5.34053 15.639 5.27819 15.5869 5.22563ZM6.75 3.37501H11.25V5.62501H6.75V3.37501ZM11.25 14.625H6.75V10.125H11.25V14.625ZM12.375 14.625V10.125C12.375 9.82664 12.2565 9.54049 12.0455 9.32952C11.8345 9.11854 11.5484 9.00001 11.25 9.00001H6.75C6.45163 9.00001 6.16548 9.11854 5.9545 9.32952C5.74353 9.54049 5.625 9.82664 5.625 10.125V14.625H3.375V3.37501H5.625V5.62501C5.625 5.92338 5.74353 6.20953 5.9545 6.4205C6.16548 6.63148 6.45163 6.75001 6.75 6.75001H11.25C11.5484 6.75001 11.8345 6.63148 12.0455 6.4205C12.2565 6.20953 12.375 5.92338 12.375 5.62501V3.60563L14.625 5.85563V14.625H12.375Z'
        fill={fill}
      />
    </svg>
  );
}
